var processInclude = require("base/util");

$(document).ready(function () {
    processInclude(require("./components/liquidCustom"));
    processInclude(require("./components/liquidPersonalization"));
});
